import React, { FC, useMemo } from 'react';
import TitleLink from '../../components/TitleLink';
import { useScreenSize } from '../../components/ScreenSize';
import NewsItem from '../../components/NewsList/NewsItem';
import NewsItemCenter from '../../components/NewsList/NewsItemCenter';
import { useNewsRelatedData } from './hook';

export interface DataType {
  [key: string]: string;
}

interface Props {
  newsNo: string;
  lanType: string;
  category: number;
}

const NewsRelated: FC<Props> = (props) => {
  const { newsNo, lanType, category } = props;
  const imgLgClass = 'overflow-hidden w-full rounded-lg lg:rounded-2xl translate-y-0'; // lg:w-25.88r
  const contentLgClass = 'lg:h-4.57r lg:flex-1';

  const { size } = useScreenSize();

  const RelatedNewsItem = useMemo(() => {
    if (size.width < 640) {
      return NewsItemCenter;
    }
    return NewsItem;
  }, [size]);

  const { newsData, showRelatedNews, newsTitleText, newsMoreText } = useNewsRelatedData(newsNo, lanType, category);

  return showRelatedNews ? (
    <section className="m-auto w-full bg-white px-5 pb-[30px] pt-[30px] sm:bg-[#F6F7F8] lg:px-0 lg:pb-[58px] lg:pt-[60px]">
      <div className="mx-auto max-w-7xl">
        <div className="pb-5">
          <TitleLink
            textVal={newsTitleText}
            linkVal={newsMoreText}
            linkUrl={category ? `/news?category=${category}` : '/news'}
            linkOut
          />
        </div>

        <div className="flex flex-col space-y-6 sm:flex-row sm:space-x-2 sm:space-y-0 lg:flex-row lg:space-x-5 lg:space-y-0">
          {newsData?.map((item, index) => (
            <div className="min-w-0 flex-1 sm:last:hidden lg:last:block" key={index}>
              <RelatedNewsItem
                imgLgClass={imgLgClass}
                itemClass="bg-transparent"
                contentLgClass={contentLgClass}
                hasAbstract={false}
                newsItemData={item}
                position={index + 1}
                source="relativeNews"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  ) : null;
};

NewsRelated.displayName = 'NewsRelated';
export default NewsRelated;
